import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'

export function useGetCampaignActivationSummary(leadSource: string) {
   const response = useSWR(
      leadSource ? [QUERY_KEYS.CAMPAIGN_ACTIVATION_SUMMARY, leadSource] : null,
      () =>
         leadSource
            ? CampaignService.getCampaignActivationSummary(leadSource)
            : null
   )

   return {
      ...response,
   }
}
